<template>
    <!-- footer -->
    <footer class="w3l-footer-22 position-relative mt-5 pt-5">
      <div class="footer-sub">
        <div class="container">
          <div class="text-txt">
            <div class="right-side">
      
            </div>
            <div class="row sub-columns">
              <div class="col-lg-2 col-sm-6 sub-two-right">
                <h6>Quick links</h6>
                <ul>
                  <li><router-link to="/"><span class="fa fa-angle-double-right mr-2"></span>Home</router-link></li>
                  <li><router-link to="/about"><span class="fa fa-angle-double-right mr-2"></span>About</router-link></li>
                  <li><router-link to="/courses"><span class="fa fa-angle-double-right mr-2"></span>Courses</router-link></li>
                  <li><router-link to="/contact"><span class="fa fa-angle-double-right mr-2"></span>Contact</router-link></li>
                </ul>
              </div>
              <div class="col-lg-3 col-sm-6 sub-two-right pl-lg-5 mt-sm-0 mt-4">
                <h6>Help & Support</h6>
                <ul>
                  <li><a href="#live"><span class="fa fa-angle-double-right mr-2"></span>Live Chart</a></li>
                  <li><router-link to="/faq"><span class="fa fa-angle-double-right mr-2"></span>Faq</router-link></li>
                  <li><a href="#support"><span class="fa fa-angle-double-right mr-2"></span>Support</a></li>
                  <li><a href="#terms"><span class="fa fa-angle-double-right mr-2"></span>Terms of Services</a></li>
                </ul>
              </div>
              <div class="col-lg-3 col-sm-6 sub-one-left mt-lg-0 mt-sm-5 mt-4">
                            <h6>Contact </h6>
                            <div class="column2">
                                <div class="href1"><span class="fa fa-envelope-o" aria-hidden="true"></span><a href="mailto:Thatschinese@163.com">Thatschinese@163.com</a>
                                </div>
                                <div class="href2"><span class="fa fa-phone" aria-hidden="true"></span><a href="tel:+86 13883135370">+86 13883135370</a>
                                </div>
                                <div>
                                    <p class="contact-para"><span class="fa fa-map-marker" aria-hidden="true"></span>That's Chinese . Chengdu, Sichuan, China</p>
                                </div>
                            </div>
                        </div>
              <div class="col-lg-4 col-sm-6 sub-one-left ab-right-cont pl-lg-5 mt-lg-0 mt-sm-5 mt-4">
                <h6>About </h6>
                <p>That's Chinese is to help expats learn Chinese language well whilst developing a better understanding of the people and place, where they live and work.</p>
                <div class="columns-2">
                  <ul class="social">
                    <li><a href="https://www.facebook.com/ThatsChinese" target="_blank"><i class="fa fa-facebook"></i></a></li>
                    <li><a href="https://www.linkedin.com/company/66298604/admin/" target="_blank"><i class="fa fa-linkedin"></i></a></li>
                    <li><a href="https://www.youtube.com/channel/UCP8xEO3ieE-vw7R_KH_Nu9Q" target="_blank"><i class="fa fa-youtube"></i></a></li>
                    <li><a href="https://www.instagram.com/thatschinese/" target="_blank"><i class="fa fa-instagram"></i></a></li>
                    <li><a href="https://mp.weixin.qq.com/s?__biz=MzU0NDkxOTU1NA==&mid=2247494077&idx=1&sn=ddc774168d99e66b7b15071cb4c21671&chksm=fb7670d0cc01f9c6f8dd3cc35bd4c1f32141b6d35caaa8763b475ad007dbb2b512e1b0b72d30&token=1804975949&lang=zh_CN#rd" target="_blank"><i class="fa fa-weixin"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright-footer text-center">
        <div class="container">
          <div class="columns">
            <p>@2023 That's Chinese. All rights reserved</p>
          </div>
        </div>
      </div>
      <!-- //copyright -->
    </footer>
    <!-- //footer -->
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped>

</style> 